import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useMediaQuery } from "react-responsive";
import MDTypography from "components/MDTypography";
import { Avatar, Card, CardContent, CardMedia } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import ExploreLoader from "components/SkeletonLoader/exploreLoader";
import { useSelector } from "react-redux";

export default function ForSale() {
  let navigate = useNavigate();
  const { nftListStatic } = useSelector((state) => state.nftMarketPlaceData);
  const { forSaleNftList } = nftListStatic;

  const {
    isWeb3Enabled,
    address,
    chainId,
    balance,
    reward,
    isWalletLoading,
    isRewardLoading,
  } = useSelector((state) => state.walletData);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    laptop: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 330 },
      items: 1,
      slidesToSlide: 1,
    },
    mobileSmall: {
      breakpoint: { max: 320, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const handleSeeAllNft = (name) => {
    navigate(`/see-all/?status=For sale`);
  };

  const handleAuctionDetail = (value) => {
    // navigate(`/auction/auctiondetails/?auctionId=${auctionId}`);
    navigate(`/auction-details/?auctionId=${value}`);
  };

  return (
    <>
      <MDBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: isTabletOrMobile ? "5%" : "5%",
          marginLeft: isTabletOrMobile ? "5%" : "5%",
          marginBottom: "1rem",
          alignItems: "center",
        }}
      >
        <MDBox>
          <MDAvatar
            sx={{
              color: "#8613A5",
              backgroundColor: "#8613A5",
              position: "absolute",
              zIndex: "-1",
              width: isTabletOrMobile ? "3rem" : "3.5rem",
              height: isTabletOrMobile ? "3rem" : "3.5rem",
              left: isTabletOrMobile ? "7px" : "28px",
              top: isTabletOrMobile ? "134px" : "170px",
            }}
          />
          <MDTypography
            sx={{ color: "#ffffff", fontSize: "22px" }}
            fontWeight="bold"
          >
            On Sale
          </MDTypography>
        </MDBox>
        <MDBox sx={{ cursor: "pointer" }}>
          <MDTypography variant="h6">
            <MDButton
              color="singh"
              variant="text"
              size="small"
              onClick={(e) => handleSeeAllNft()}
              sx={{ textDecoration: "underline" }}
            >
              View All
              <ArrowForwardIosIcon sx={{}} />
            </MDButton>
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox
        sx={{
          marginBottom: "2rem",
          marginRight: isTabletOrMobile ? null : "2.5%",
          marginLeft: isTabletOrMobile ? null : "2.5%",
        }}
      >
        {forSaleNftList.length > 0 ? (
          <Carousel autoPlay={true} responsive={responsive} infinite={true}>
            {forSaleNftList.map((item, idx) => (
              <Card
                key={idx}
                sx={{
                  margin: 0,
                  cursor: "pointer",
                  // width: "275px",
                  // height: isTabletOrMobile ? "385px" : "380px",
                  marginRight: "5px",
                  marginLeft: "5px",
                  backgroundColor: "#052330",
                }}
                onClick={() => handleAuctionDetail(item._id)}
                // onClick={() => handleData(item)}
              >
                <MDBox sx={{ height: "320px" }}>
                  <img
                    src={item.postDetails.photo}
                    style={{
                      objectFit: "cover",
                      borderRadius: "10px 10px 0px 0px",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                </MDBox>
                <MDBox
                  sx={{
                    position: "absolute",
                    top: 10,
                    marginLeft: "5px",
                    width: "90px",
                    backgroundColor: "#000000",
                    opacity: "60%",
                    borderRadius: "15px",
                    textAlign: "center",
                  }}
                ></MDBox>

                <MDBox sx={{ padding: 1 }}>
                  <MDBox
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <MDBox
                      sx={{
                        display: "flex",
                        gap: "0.5rem",
                        alignItems: "center",
                      }}
                    >
                      <MDBox>
                        <MDAvatar
                          src={item.userDetails.pic}
                          size="xs"
                          sx={{ width: "40px", height: "40px" }}
                          imgProps={{
                            style: { height: "100%", width: "100%" },
                          }}
                        />
                      </MDBox>
                      <MDBox>
                        <MDTypography
                          fontWeight="bold"
                          fontSize="12px"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          whiteSpace="nowrap"
                          width="80px"
                        >
                          {item.name}
                        </MDTypography>
                        <MDTypography
                          fontSize="12px"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          whiteSpace="nowrap"
                          width="80px"
                          sx={{ color: "#BDAAC1" }}
                        >
                          by @{item.userDetails.username}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    {item.price === null ||
                    item.price === undefined ||
                    item.price === 0 ||
                    item.price === "0" ? null : (
                      <MDBox
                        sx={
                          {
                            //  textAlign: "end"
                          }
                        }
                      >
                        <MDBox
                          sx={{
                            display: "flex",
                            // justifyContent: "space-between",
                            // textAlign: "start",
                            // marginRight: "-25px",
                          }}
                          // overflow="hidden"
                          // textOverflow="ellipsis"
                          // whiteSpace="nowrap"
                          // width="50px"
                        >
                          <MDBox sx={{ height: "30px", width: "30px" }}>
                            <img
                              src={singhCoinCurrency}
                              height="100%"
                              width="100%"
                              alt="currentSymbol"
                            />
                          </MDBox>
                          <MDBox sx={{ width: "40px" }}>
                            <MDTypography
                              color="white"
                              fontWeight="bold"
                              fontSize="medium"
                              overflow="hidden"
                              textOverflow="ellipsis"
                              whiteSpace="nowrap"
                              // width="50px"
                              sx={{ marginTop: "2px" }}
                            >
                              {item.price}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox>
                          <MDTypography
                            sx={{ fontSize: "12px", color: "#BDAAC1" }}
                          >
                            Current price
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
                <MDBox sx={{ width: "100%", padding: "10px" }}>
                  <MDButton
                    fullWidth
                    sx={{
                      borderRadius: "10px",
                      backgroundImage:
                        "linear-gradient(90deg, rgba(74, 74, 74, 0.8) 20%, rgba(255, 147, 8, 0.9) 80%);",
                      // border:"1px solid #FF9607",
                      color: "#ffffff",
                    }}
                  >
                    {item.userDetails.walletAddress === address
                      ? "View Details"
                      : "Buy Now"}
                  </MDButton>
                </MDBox>
              </Card>
            ))}
          </Carousel>
        ) : (
          <ExploreLoader />
        )}
      </MDBox>
    </>
  );
}
